module.exports = __webpack_public_path__ + "img/virtual-exhibition-hall-link-icon.77ea6fc3.png";